import { LOCAL_STORAGE_STATE_PERSIST } from '@/utils/constants/checkin.constants';

export const initialState = {
  data: {
    hasSentToAnalyze: false,
    uploadedMedicalOrders: []
  }

};

export const getInitialState = () => {
  const savedData = localStorage.getItem(LOCAL_STORAGE_STATE_PERSIST);

  if (savedData) {
    const parsedData = JSON.parse(savedData);

    return parsedData.medicalOrders;
  }

  return initialState;
};

export const state = getInitialState();
